import ErrorIcon from './ErrorIcon'

export default ErrorIcon
